import type { GraftcodeOnboardingScenarioId } from '../graftcode-onboarding.const'
import { getStackLabel } from '../graftcode-onboarding-stacks.const'

export type OnboardingRequirementChip = {
  label: string
  href: string
}

export function getOnboardingRequirementChips(
  scenarioId: GraftcodeOnboardingScenarioId,
  stackId: string
): OnboardingRequirementChip[] {
  const lang = getStackLabel(stackId)
  const requirements: OnboardingRequirementChip[] = []

  if (scenarioId === 'frontend') {
    requirements.push({ label: 'Git', href: 'https://git-scm.com/downloads' })
  }
  if (!['frontend', 'modules', 'microservices'].includes(scenarioId)) {
    requirements.push({ label: 'Docker', href: 'https://docs.docker.com/desktop/' })
  }
  if (scenarioId === 'frontend' || stackId === 'javascript') {
    requirements.push({ label: 'Node.js', href: 'https://nodejs.org/en/download' })
  }
  if (lang === 'Angular') {
    requirements.push({ label: 'Angular CLI', href: 'https://angular.dev/tools/cli/setup-local' })
  }
  if (lang === '.NET' || (scenarioId === 'modules' && lang === 'Python')) {
    requirements.push({ label: '.NET SDK', href: 'https://dotnet.microsoft.com/en-us/download' })
  }
  if (lang === 'Python' || (scenarioId === 'modules' && lang !== 'Python')) {
    requirements.push({ label: 'Python', href: 'https://www.python.org/downloads/' })
  }
  if (['Java', 'Kotlin', 'Groovy'].includes(lang) && ['microservices', 'modules'].includes(scenarioId)) {
    requirements.push(
      { label: 'JDK 21', href: 'https://adoptium.net/temurin/releases?version=21' },
      { label: 'Maven', href: 'https://maven.apache.org/install.html' }
    )
  }
  if (scenarioId === 'mcp') {
    requirements.push({
      label: 'AI client with MCP',
      href: 'https://docs.graftcode.com/quick-start/expose-mcp/javascript',
    })
  }

  return requirements
}
